webpackJsonp([2],{

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(642),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f03917f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(397);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = examinePass;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateLastProblemUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDshProblemByID;
/* harmony export (immutable) */ __webpack_exports__["b"] = getProblemByGuidManager;
/* harmony export (immutable) */ __webpack_exports__["f"] = checkAnswerByGuid;
/* harmony export (immutable) */ __webpack_exports__["g"] = getProblemByGuid;
/* harmony export (immutable) */ __webpack_exports__["h"] = getNextProblemGuid;
/* unused harmony export uploadProblemImg */
/* harmony export (immutable) */ __webpack_exports__["e"] = editProblemByGuid;
/* harmony export (immutable) */ __webpack_exports__["a"] = deltetPreProblemById;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function examinePass(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/examinePass',
    data: data,
    method: 'post'
  });
}

function updateLastProblemUser(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/updateLastProblemUser',
    data: data,
    method: 'post'
  });
}

function getDshProblemByID(id) {
  console.log('api---id=' + id);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getDshProblemByID',
    params: {
      id: id
    },
    method: 'get'
  });
}

function getProblemByGuidManager(guid) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getProblemByGuidManager',
    params: {
      guid: guid
    },
    method: 'get'
  });
}

function checkAnswerByGuid(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/checkAnswerByGuid',
    data: data,
    method: 'post'
  });
}

function getProblemByGuid(guid) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getProblemByGuid',
    params: {
      guid: guid
    },
    method: 'get'
  });
}

function getNextProblemGuid(guid, passtype) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/getNextProblemGuid',
    params: {
      guid: guid,
      passtype: passtype
    },
    method: 'get'
  });
}

function uploadProblemImg(formdata) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/uploadProblemImg',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 10000,
    data: formdata
  });
}

function editProblemByGuid(guid) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/editProblemByGuid',
    data: guid,
    method: 'post'
  });
}

function deltetPreProblemById(id) {
  console.log('api deltetPreProblemById  id =' + id);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/deltetPreProblemById',
    data: id,
    method: 'post'
  });
}

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(396);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(34);


var ExamineProblemDlgConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__webpack_require__(500));

var instance = void 0;

var examineProblemDlg = function examineProblemDlg(options) {
  options = options || {};
  if (!instance) {
    instance = new ExamineProblemDlgConstructor({
      data: options,
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
  }

  instance.vm.dshid = options.dshid;
  instance.vm.isEditData = options.isEditData;
  instance.vm.guid = options.guid;
  instance.vm.show = true;
  return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (examineProblemDlg);

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(34);


var KnowledgeDlgConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__webpack_require__(501));

var instance = void 0;

var knowledgeDlg = function knowledgeDlg(options) {
  options = options || {};
  if (!instance) {
    instance = new KnowledgeDlgConstructor({
      data: options,
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
  }

  instance.vm.guid = options.guid;
  instance.vm.isEditData = options.isEditData;
  instance.vm.loadData();
  instance.vm.show = true;
  return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (knowledgeDlg);

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_quill_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_knowledge_js__ = __webpack_require__(101);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      loading: false,
      tempstr: '',
      showEditBtn: false,
      type: '0',
      guid: '',
      dshid: -1,
      isEditData: false,
      pInfo1: {
        id: 0,
        guid: '',
        type1: '',
        type2: '',
        type3: '',
        type4: '',
        main: 1,
        minor: 1,
        aisnumber: '',
        aformat: '',
        keyword: '',
        title: '',
        content: '',
        atype: '',
        amark: '',
        aselect: '',
        answer: '',
        rank: 0,
        author2: '',
        animateJSNames: ''
      },
      kInfo: {
        guid: '',
        title: '',
        type: '',
        content: '',
        author2Guid: '',
        description: '',
        keyword2: ''
      },
      toolbarOptions: [[{ 'table': ['newtable_1_1', 'newtable_1_2', 'newtable_1_3', 'newtable_1_4', 'newtable_1_5', 'newtable_2_1', 'newtable_2_2', 'newtable_2_3', 'newtable_2_4', 'newtable_2_5', 'newtable_3_1', 'newtable_3_2', 'newtable_3_3', 'newtable_3_4', 'newtable_3_5'] }], [{ 'table': 'append-row' }], [{ 'table': 'append-col' }], [{ 'table': 'remove-row' }], [{ 'table': 'remove-col' }], [{ 'table': 'remove-table' }], [{ 'table': 'cell-background' }], ['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], ['link', 'image'], ['formula', 'clean', 'video']],
      quill: null
    };
  },

  computed: {
    title: function title() {
      if (this.isEditData === true) {
        this.showEditBtn = true;
      } else {
        this.showEditBtn = false;
      }
      return '\u5BA1\u6838\u9898\u76EE-' + (this.isEditData === true ? '修改' : '新增');
    }
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.markDown();
      }
    }
  },
  methods: {
    markDown: function markDown() {
      var _this = this;

      setTimeout(function () {
        var options = {
          modules: {
            formula: true,
            syntax: true,
            toolbar: {
              container: _this.toolbarOptions,
              handlers: {
                image: _this.imageHandler
              }
            }
          },
          scrollingContainer: '#standalone-container',
          placeholder: 'Compose an epic...',
          theme: 'snow'
        };

        if (!_this.quill) {
          _this.quill = new window.Quill('#editor', options);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_quill_table__["setEditor"])(_this.quill);
        }
        _this.loadData();
      }, 1000);
    },
    closeDlg: function closeDlg() {
      this.show = false;
    },
    imageHandler: function imageHandler() {
      console.log('65');
      var range = this.quill.getSelection();
      var value = prompt('What is the image URL');
      this.quill.insertEmbed(range.index, 'image', value, window.Quill.sources.USER);
    },
    showMsg: function showMsg(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';

      this.$notify({
        title: '审核题目',
        message: msg,
        type: type
      });
    },
    loadData: function loadData() {
      var _this2 = this;

      if (this.isEditData === true) {
        this.loading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["b" /* getProblemByGuidManager */])(this.guid).then(function (res) {
          var data = res.data;
          if (data.isOk) {
            _this2.pInfo1 = data.data[0];
            var tm = JSON.parse(_this2.pInfo1.content);
            console.log(tm.ops);
            if (_this2.quill) {
              _this2.quill.setContents(tm.ops);
              _this2.quill.enable(true);
            } else {
              console.log('quill初始化失败。');
            }
          } else {
            _this2.showMsg('获取题目信息失败，请关闭修改对话框后重新再试！');
          }
          _this2.loading = false;
        }).catch(function (err) {
          _this2.showMsg(err);
          _this2.loading = false;
        });
      } else {
        this.loading = true;
        console.log('this.dshid==' + this.dshid);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["c" /* getDshProblemByID */])(this.dshid).then(function (res) {
          var data = res.data;
          if (data.isOk) {
            _this2.pInfo1 = data.data[0];
            var tm = JSON.parse(_this2.pInfo1.content);
            console.log(tm.ops);
            if (_this2.quill) {
              _this2.quill.setContents(tm.ops);
              _this2.quill.enable(true);
            } else {
              console.log('quill初始化失败。');
            }
          } else {
            _this2.showMsg('获取题目信息失败，请关闭修改对话框后重新再试！');
          }
          _this2.loading = false;
        }).catch(function (err) {
          _this2.showMsg(err);
          _this2.loading = false;
        });
      }
    },
    examine1: function examine1() {
      var _this3 = this;

      console.log('审核通过并创建新题目，this.pInfo1=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.pInfo1));
      this.pInfo1.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.quill.getContents());
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["d" /* examinePass */])(this.pInfo1).then(function (res) {
        if (res.data) {
          if (res.data.isOk === true) {
            _this3.showMsg('创建新题目成功。', 'info');
          } else {
            _this3.showMsg('创建新题目失败。', 'info');
          }
        } else {
          _this3.showMsg('创建新题目不成功。', 'info');
        }
      }).catch(function (err) {
        _this3.showMsg('\u4FDD\u5B58\u65B0\u9898\u5931\u8D25\u3002' + err);
      });
    },
    saveEdit: function saveEdit() {
      var _this4 = this;

      console.log('修改题目 this.pInfo1=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.pInfo1));
      this.pInfo1.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.quill.getContents());
      console.log('this.pInfo1.content=' + this.pInfo1.content);
      delete this.pInfo1['id'];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["e" /* editProblemByGuid */])(this.pInfo1).then(function (res) {
        if (res.data) {
          console.log('修改题目 res.data=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data));
          if (res.data.isOk === true) {
            _this4.showMsg('修改新题目成功。', 'info');
          } else {
            _this4.showMsg('修改新题目失败。', 'info');
          }
        } else {
          _this4.showMsg('修改新题目不成功。', 'info');
        }
      }).catch(function (err) {
        _this4.showMsg('\u4FEE\u6539\u65B0\u9898\u5931\u8D25\u3002' + err);
      });
    },
    testCheckAnswer: function testCheckAnswer() {
      var _this5 = this;

      var answerInfo = {};
      answerInfo.answer = 'B';
      answerInfo.pmain = 1;
      answerInfo.passtype = 2;
      answerInfo.pguid = '5d64c6f08bd511e787c68980854367e6';
      answerInfo.pminor = 1;
      console.log('anwserInfo1=', answerInfo);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["f" /* checkAnswerByGuid */])(answerInfo).then(function (res) {
        if (res.data) {
          if (res.data.isOk === true) {
            _this5.showMsg('checkAnswerByGuid1。', 'info');
          } else {
            _this5.showMsg('checkAnswerByGuid2。', 'info');
          }
        } else {
          _this5.showMsg('checkAnswerByGuid3。', 'info');
        }
      }).catch(function (err) {
        _this5.showMsg('checkAnswerByGuid4\u3002' + err);
      });
    },
    testGetProblemGuids: function testGetProblemGuids() {
      var _this6 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["g" /* getProblemByGuid */])(this.guid).then(function (res) {
        var data = res.data;
        console.log('--data--', data);
        if (data.isOk) {} else {
          _this6.showMsg('获取题目GUID失败！');
        }
      });
    },
    testGetNextProblemGuids: function testGetNextProblemGuids() {
      var _this7 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["h" /* getNextProblemGuid */])(this.guid, 1).then(function (res) {
        var data = res.data;
        console.log('--data--', data);
        if (data.isOk) {} else {
          _this7.showMsg('获取题目GUID失败！');
        }
      });
    },
    updateLastProblemU: function updateLastProblemU() {
      var _this8 = this;

      var level = {};
      level.pmain = this.pInfo1.main;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_examine_js__["i" /* updateLastProblemUser */])(level).then(function (res) {
        _this8.showMsg(res.data);
      });
    },
    commit2knowledge: function commit2knowledge() {
      var _this9 = this;

      this.kInfo.title = this.pInfo1.title;
      this.kInfo.content = this.pInfo1.content;
      this.kInfo.type = this.pInfo1.type1;
      this.kInfo.author2Guid = this.pInfo1.author2;
      this.kInfo.keyword2 = this.pInfo1.keyword2;
      this.kInfo.description = this.pInfo1.description;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_api_knowledge_js__["e" /* addNewKnowledge */])(this.kInfo).then(function (res) {
        if (res.data) {
          if (res.data.isOk === true) {
            _this9.showMsg('添加知识点成功。', 'info');
          } else {
            _this9.showMsg('添加知识点失败。', 'info');
          }
        } else {
          _this9.showMsg('添加知识点不成功。', 'info');
        }
      }).catch(function (err) {
        _this9.showMsg('\u6DFB\u52A0\u77E5\u8BC6\u70B9\u5931\u8D25\u3002' + err);
      });
    }
  }
});

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_knowledge_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_quill_table__ = __webpack_require__(59);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      loading: false,
      tempstr: '',
      guid: '',
      isEditData: false,
      kInfo1: {
        guid: '',
        title: '',
        type: '',
        content: '',
        author2Guid: '',
        description: '',
        keyword2: ''
      },
      quill: null,
      toolbarOptions: [[{ 'table': ['newtable_1_1', 'newtable_1_2', 'newtable_1_3', 'newtable_1_4', 'newtable_1_5', 'newtable_2_1', 'newtable_2_2', 'newtable_2_3', 'newtable_2_4', 'newtable_2_5', 'newtable_3_1', 'newtable_3_2', 'newtable_3_3', 'newtable_3_4', 'newtable_3_5'] }], [{ 'table': 'append-row' }], [{ 'table': 'append-col' }], [{ 'table': 'remove-row' }], [{ 'table': 'remove-col' }], [{ 'table': 'remove-table' }], [{ 'table': 'cell-background' }], ['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'align': [] }], ['link', 'image'], ['formula', 'clean', 'video']]
    };
  },

  computed: {
    title: function title() {
      return '\u7F16\u8F91\u77E5\u8BC6\u70B9-' + (this.isEditData === true ? '修改' : '新增');
    }
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.markDown();
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    markDown: function markDown() {
      var _this = this;

      setTimeout(function () {
        if (!_this.quill) {
          _this.quill = new window.Quill('#editor', {
            modules: {
              formula: true,
              syntax: true,
              toolbar: {
                container: _this.toolbarOptions,
                handlers: {
                  image: _this.imageHandler
                }
              }
            },
            placeholder: 'Compose an epic...',
            theme: 'snow'
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_quill_table__["setEditor"])(_this.quill);
          if (_this.isEditData === true) {
            _this.loadData();
          }
        }
      }, 1000);
    },
    imageHandler: function imageHandler() {
      console.log('65');
      var range = this.quill.getSelection();
      var value = prompt('What is the image URL');
      this.quill.insertEmbed(range.index, 'image', value, window.Quill.sources.USER);
    },
    closeDlg: function closeDlg() {
      this.show = false;
    },
    showMsg: function showMsg(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';

      this.$notify({
        title: '知识点',
        message: msg,
        type: type
      });
    },
    weixin: function weixin() {
      var d = {};
      d.mch_id = 'wx9e060fd2c6b37704';
      d.nonce_str = 'thiskInfo1content';
      d.sign = 'EdfO0uMgB41qSxy1WckKcVuOGdfhZc6JnMGMU3pbIF2';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_knowledge_js__["c" /* weixintest */])(d).then(function (res) {
        if (res) {
          console.log('wei xin res1=' + res);
        } else {
          console.log('wei xin res2=' + res);
        }
      }).catch(function (err) {
        console.log('wei xin err=' + err);
      });
    },
    saveKnowledge: function saveKnowledge() {
      var _this2 = this;

      console.log('保存知识点 this.kInfo1=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.kInfo1));
      this.kInfo1.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.quill.getContents());
      if (this.isEditData === true) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_knowledge_js__["d" /* updateKnowledgeByGuid */])(this.kInfo1).then(function (res) {
          if (res.data) {
            if (res.data.isOk === true) {
              _this2.showMsg('修改知识点成功。', 'info');
            } else {
              _this2.showMsg('修改知识点失败。', 'info');
            }
          } else {
            _this2.showMsg('修改知识点不成功。', 'info');
          }
        }).catch(function (err) {
          _this2.showMsg('\u4FEE\u6539\u77E5\u8BC6\u70B9\u5931\u8D25\u3002' + err);
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_knowledge_js__["e" /* addNewKnowledge */])(this.kInfo1).then(function (res) {
          if (res.data) {
            if (res.data.isOk === true) {
              _this2.showMsg('添加知识点成功。', 'info');
            } else {
              _this2.showMsg('添加知识点失败。', 'info');
            }
          } else {
            _this2.showMsg('添加知识点不成功。', 'info');
          }
        }).catch(function (err) {
          _this2.showMsg('\u6DFB\u52A0\u77E5\u8BC6\u70B9\u5931\u8D25\u3002' + err);
        });
      }
    },
    loadData: function loadData() {
      var _this3 = this;

      console.log('knowledge--load data,guid=' + this.guid);
      if (this.isEditData === true) {
        this.loading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_knowledge_js__["f" /* getKnowledgeByGuid */])(this.guid).then(function (res) {
          var data = res.data;
          if (data.isOk) {
            _this3.kInfo1 = data.data[0];
            var tk = JSON.parse(_this3.kInfo1.content);
            console.log(tk.ops);
            if (_this3.quill) {
              _this3.quill.setContents(tk.ops);
              _this3.quill.enable(true);
            } else {
              console.log('quill初始化失败。');
            }
          } else {
            _this3.showMsg('获取知识点失败，请关闭修改对话框后重新再试！');
          }
          _this3.loading = false;
        }).catch(function (err) {
          _this3.showMsg(err);
          _this3.loading = false;
        });
      }
    }
  }
});

/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_knowledgeDlg__ = __webpack_require__(337);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cols: [{
        prop: 'guid',
        label: 'guid',
        width: 150
      }, {
        prop: 'title',
        label: '标题',
        width: 280
      }, {
        prop: 'type',
        label: '类型',
        width: 80
      }, {
        prop: 'date',
        label: '日期',
        width: 100
      }]
    };
  },

  props: ['tableData'],
  computed: {
    tabH: function tabH() {
      return this.winH - (this.search ? this.search.getHeight() : 80) - 88;
    }
  },
  methods: {
    edit: function edit(guid) {
      console.log('knowledgeDlg->edit id = ', guid);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_knowledgeDlg__["a" /* default */])({
        isEditData: true,
        guid: guid
      });
    }
  }
});

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".h20{height:20px}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/components/examineProblemDlg/src/main.vue"],"names":[],"mappings":"AACA,KACE,WAAa,CACd","file":"main.vue","sourcesContent":["\n.h20{\n  height: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"knowledgeTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(420);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("8a274478", content, true);

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(421);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("281cf108", content, true);

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(422);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("9bbb07e8", content, true);

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(448)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(503),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(505),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "pInfo1",
    attrs: {
      "model": _vm.pInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "guid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "guid,修改时用"
    },
    model: {
      value: (_vm.pInfo1.guid),
      callback: function($$v) {
        _vm.pInfo1.guid = $$v
      },
      expression: "pInfo1.guid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "归类1"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "显示到最上方的类别"
    },
    model: {
      value: (_vm.pInfo1.type1),
      callback: function($$v) {
        _vm.pInfo1.type1 = $$v
      },
      expression: "pInfo1.type1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "归类2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备用，尚未用到"
    },
    model: {
      value: (_vm.pInfo1.type2),
      callback: function($$v) {
        _vm.pInfo1.type2 = $$v
      },
      expression: "pInfo1.type2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "关键词"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "会显示到类别1的下方"
    },
    model: {
      value: (_vm.pInfo1.keyword),
      callback: function($$v) {
        _vm.pInfo1.keyword = $$v
      },
      expression: "pInfo1.keyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "此处文字会显示到正文中，可写可不写，最好写上"
    },
    model: {
      value: (_vm.pInfo1.title),
      callback: function($$v) {
        _vm.pInfo1.title = $$v
      },
      expression: "pInfo1.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "原作者"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原作者"
    },
    model: {
      value: (_vm.pInfo1.author2),
      callback: function($$v) {
        _vm.pInfo1.author2 = $$v
      },
      expression: "pInfo1.author2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案类型"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "0为输入，1为单选题，2为多选题"
    },
    model: {
      value: (_vm.pInfo1.atype),
      callback: function($$v) {
        _vm.pInfo1.atype = $$v
      },
      expression: "pInfo1.atype"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案标记"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "即显示在输入答案前的提示，同时也是选择题选项"
    },
    model: {
      value: (_vm.pInfo1.amark),
      callback: function($$v) {
        _vm.pInfo1.amark = $$v
      },
      expression: "pInfo1.amark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案是否数值"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "数值为1，字符为0，逗号分隔，，如果是多个输入，需要全写，如三个是1,1,1"
    },
    model: {
      value: (_vm.pInfo1.aisnumber),
      callback: function($$v) {
        _vm.pInfo1.aisnumber = $$v
      },
      expression: "pInfo1.aisnumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案格式"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "答案格式，如输入一个整数，输入一个字符，输入一个小数，保留两位小数等，多个用逗号分隔"
    },
    model: {
      value: (_vm.pInfo1.aformat),
      callback: function($$v) {
        _vm.pInfo1.aformat = $$v
      },
      expression: "pInfo1.aformat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "答案"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "答案"
    },
    model: {
      value: (_vm.pInfo1.answer),
      callback: function($$v) {
        _vm.pInfo1.answer = $$v
      },
      expression: "pInfo1.answer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "主题号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "主题号，知识点大题号"
    },
    model: {
      value: (_vm.pInfo1.main),
      callback: function($$v) {
        _vm.pInfo1.main = $$v
      },
      expression: "pInfo1.main"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "次题号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "次题号，知识点内小题号"
    },
    model: {
      value: (_vm.pInfo1.minor),
      callback: function($$v) {
        _vm.pInfo1.minor = $$v
      },
      expression: "pInfo1.minor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "等级点"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "等级变化点，24k为1，23k为2，22k为3...."
    },
    model: {
      value: (_vm.pInfo1.rank),
      callback: function($$v) {
        _vm.pInfo1.rank = $$v
      },
      expression: "pInfo1.rank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "keyword2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的keywords，尽量多填"
    },
    model: {
      value: (_vm.pInfo1.keyword2),
      callback: function($$v) {
        _vm.pInfo1.keyword2 = $$v
      },
      expression: "pInfo1.keyword2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的description，尽量多填"
    },
    model: {
      value: (_vm.pInfo1.description),
      callback: function($$v) {
        _vm.pInfo1.description = $$v
      },
      expression: "pInfo1.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "动画JS名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "只写名称如12k_pid_6,forward_1等，不加.js，多个用逗号分隔"
    },
    model: {
      value: (_vm.pInfo1.animateJSNames),
      callback: function($$v) {
        _vm.pInfo1.animateJSNames = $$v
      },
      expression: "pInfo1.animateJSNames"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDlg
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.showEditBtn) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEdit
    }
  }, [_vm._v("保存修改")]) : _vm._e(), _vm._v(" "), (_vm.type == 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.examine1
    }
  }, [_vm._v("创建新题目，审核通过")]) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "flex",
      "align": "middle",
      "justify": "center"
    }
  }, [(_vm.type == 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateLastProblemU
    }
  }, [_vm._v("更新已做到最后一题的用户")]) : _vm._e(), _vm._v(" "), (_vm.type == 0) ? _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.commit2knowledge
    }
  }, [_vm._v("提交本题到知识点")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("题目内容")])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "margin": "10px auto",
      "max-width": "100%"
    },
    attrs: {
      "id": "standalone-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "toolbar"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "calc(100vh - 220px)"
    },
    attrs: {
      "id": "editor"
    }
  })])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "kInfo1",
    attrs: {
      "model": _vm.kInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "guid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "guid"
    },
    model: {
      value: (_vm.kInfo1.guid),
      callback: function($$v) {
        _vm.kInfo1.guid = $$v
      },
      expression: "kInfo1.guid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "标题,60字以内"
    },
    model: {
      value: (_vm.kInfo1.title),
      callback: function($$v) {
        _vm.kInfo1.title = $$v
      },
      expression: "kInfo1.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "类型,60字以内"
    },
    model: {
      value: (_vm.kInfo1.type),
      callback: function($$v) {
        _vm.kInfo1.type = $$v
      },
      expression: "kInfo1.type"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原作者GUID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原作者GUID,如果没有，需填入0"
    },
    model: {
      value: (_vm.kInfo1.author2Guid),
      callback: function($$v) {
        _vm.kInfo1.author2Guid = $$v
      },
      expression: "kInfo1.author2Guid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "keyword2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的keywords，尽量多填"
    },
    model: {
      value: (_vm.kInfo1.keyword2),
      callback: function($$v) {
        _vm.kInfo1.keyword2 = $$v
      },
      expression: "kInfo1.keyword2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的description，尽量多填"
    },
    model: {
      value: (_vm.kInfo1.description),
      callback: function($$v) {
        _vm.kInfo1.description = $$v
      },
      expression: "kInfo1.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.saveKnowledge
    }
  }, [_vm._v("保存知识点")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("知识点内容")])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "margin": "50px auto",
      "max-width": "100%"
    },
    attrs: {
      "id": "standalone-container_zsd"
    }
  }, [_c('div', {
    attrs: {
      "id": "toolbar"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "calc(100vh - 200px)"
    },
    attrs: {
      "id": "editor"
    }
  })])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "height": _vm.tabH
    }
  }, [_vm._l((_vm.cols), function(col) {
    return _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "show-overflow-tooltip": ""
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "修改",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(525);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(532);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(34);


var HintDlgConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__webpack_require__(616));

var instance = void 0;

var hintDlg = function hintDlg(options) {
  options = options || {};
  if (!instance) {
    instance = new HintDlgConstructor({
      data: options,
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
  }

  instance.vm.tmguid = options.tmguid;

  instance.vm.isEditData = options.isEditData;

  instance.vm.guid = options.guid;
  instance.vm.show = true;
  return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (hintDlg);

/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(527);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(34);


var HintTableFatherDlgConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__webpack_require__(617));

var instance = void 0;

var hintTableFatherDlg = function hintTableFatherDlg(options) {
  options = options || {};
  if (!instance) {
    instance = new HintTableFatherDlgConstructor({
      data: options,
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
  }

  console.log('options=', options);
  instance.vm.tmguid = options.tmguid;
  instance.vm.show = true;
  return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (hintTableFatherDlg);

/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(529);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(34);


var KnowledgeTableFatherDlgConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__webpack_require__(619));

var instance = void 0;

var knowledgeTableFatherDlg = function knowledgeTableFatherDlg(options) {
  options = options || {};
  if (!instance) {
    instance = new KnowledgeTableFatherDlgConstructor({
      data: options,
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
  }

  console.log('options=', options);
  instance.vm.tmguid = options.tmguid;
  instance.vm.show = true;
  return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (knowledgeTableFatherDlg);

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(34);


var SolutionDlgConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__webpack_require__(626));

var instance = void 0;

var solutionDlg = function solutionDlg(options) {
  options = options || {};
  if (!instance) {
    instance = new SolutionDlgConstructor({
      data: options,
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
  }

  instance.vm.tmguid = options.tmguid;

  instance.vm.isEditData = options.isEditData;

  instance.vm.guid = options.guid;
  instance.vm.show = true;
  return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (solutionDlg);

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(534);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(34);


var SolutionTableFatherDlgConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__webpack_require__(627));

var instance = void 0;

var solutionTableFatherDlg = function solutionTableFatherDlg(options) {
  options = options || {};
  if (!instance) {
    instance = new SolutionTableFatherDlgConstructor({
      data: options,
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
  }

  console.log('options=', options);
  instance.vm.tmguid = options.tmguid;
  instance.vm.show = true;
  return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (solutionTableFatherDlg);

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_hint_js__ = __webpack_require__(103);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      loading: false,
      tempstr: '',
      guid: '',
      tmguid: '',
      isEditData: false,
      hInfo1: {
        id: 0,
        guid: '',
        pGuid: '',
        hLevel: '',
        content: '',
        title: '',
        date: ''
      },
      quill: null
    };
  },

  computed: {
    title: function title() {
      return '\u7F16\u8F91\u89E3\u9898\u63D0\u793A-' + (this.isEditData === true ? '修改' : '新增');
    }
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.markDown();
      }
      this.hInfo1.pGuid = this.tmguid;
    }
  },
  methods: {
    markDown: function markDown() {
      var _this = this;

      setTimeout(function () {
        if (!_this.quill) {
          _this.quill = new window.Quill('#editor-container-jtgc', {
            modules: {
              formula: true,
              syntax: true,
              toolbar: {
                container: '#toolbar-container-jtgc',
                handlers: {
                  image: _this.imageHandler
                }
              }
            },
            placeholder: 'Compose an epic...',
            theme: 'snow'
          });
        }
        if (_this.isEditData === true) {
          _this.loadData();
        }
      }, 1000);
    },
    imageHandler: function imageHandler() {
      console.log('65');
      var range = this.quill.getSelection();
      var value = prompt('What is the image URL');
      this.quill.insertEmbed(range.index, 'image', value, window.Quill.sources.USER);
    },
    closeDlg: function closeDlg() {
      this.show = false;
    },
    showMsg: function showMsg(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';

      this.$notify({
        title: '解题提示',
        message: msg,
        type: type
      });
    },
    saveHint: function saveHint() {
      var _this2 = this;

      this.hInfo1.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.quill.getContents());
      console.log('save hint');
      if (this.isEditData === false) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_hint_js__["b" /* addNewHint */])(this.hInfo1).then(function (res) {
          if (res.data) {
            if (res.data.isOk === true) {
              _this2.showMsg('添加解题提示成功。', 'info');
            } else {
              _this2.showMsg('添加解题提示失败。', 'info');
            }
          } else {
            _this2.showMsg('添加解题提示不成功。', 'info');
          }
        }).catch(function (err) {
          _this2.showMsg('\u6DFB\u52A0\u89E3\u9898\u63D0\u793A\u5931\u8D25\u3002' + err);
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_hint_js__["c" /* updateHintByGuid */])(this.hInfo1).then(function (res) {
          if (res.data) {
            if (res.data.isOk === true) {
              _this2.showMsg('修改解题提示成功。', 'info');
            } else {
              _this2.showMsg('修改解题提示失败。', 'info');
            }
          } else {
            _this2.showMsg('修改解题提示不成功。', 'info');
          }
        }).catch(function (err) {
          _this2.showMsg('\u4FEE\u6539\u89E3\u9898\u63D0\u793A\u5931\u8D25\u3002' + err);
        });
      }
    },
    loadData: function loadData() {
      var _this3 = this;

      if (this.isEditData === true) {
        this.loading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_hint_js__["d" /* getHintByGuid */])(this.guid).then(function (res) {
          var data = res.data;
          if (data.isOk) {
            _this3.hInfo1 = data.data[0];
            var tm = JSON.parse(_this3.hInfo1.content);
            console.log(tm.ops);
            if (_this3.quill) {
              _this3.quill.setContents(tm.ops);
              _this3.quill.enable(true);
            } else {
              console.log('quill初始化失败。');
            }
          } else {
            _this3.showMsg('获取解题提示失败，请关闭修改对话框后重新再试！');
          }
          _this3.loading = false;
        }).catch(function (err) {
          _this3.showMsg(err);
          _this3.loading = false;
        });
      }
    }
  }
});

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hintTable_hintTable__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hintTable_hintTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_hintTable_hintTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hintDlg__ = __webpack_require__(520);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      loading: false,
      tempstr: '',
      guid: '',
      tmguid: '',
      id: -1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['hintList']), {
    title: function title() {
      return '\u89E3\u9898\u63D0\u793A\u5217\u8868';
    }
  }),
  created: function created() {},

  components: {
    hintTable: __WEBPACK_IMPORTED_MODULE_2__components_hintTable_hintTable___default.a,
    hintDlg: __WEBPACK_IMPORTED_MODULE_3__components_hintDlg__["a" /* default */]
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.$store.dispatch('actions_getHintList', this.tmguid);
      }
    }
  },
  methods: {
    addHint: function addHint() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_hintDlg__["a" /* default */])({
        isEditData: false,
        tmguid: this.tmguid
      });
    }
  }
});

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hintDlg__ = __webpack_require__(520);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cols: [{
        prop: 'guid',
        label: 'guid',
        width: 150
      }, {
        prop: 'pGuid',
        label: '题目id',
        width: 80
      }, {
        prop: 'hLevel',
        label: '提示级别',
        width: 80
      }, {
        prop: 'content',
        label: '提示内容',
        width: 80
      }, {
        prop: 'date',
        label: '日期',
        width: 100
      }]
    };
  },

  props: ['tableData'],
  computed: {
    tabH: function tabH() {
      return this.winH - (this.search ? this.search.getHeight() : 80) - 88;
    }
  },
  methods: {
    edit: function edit(guid) {
      console.log('hintDlg->edit guid = ', guid);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_hintDlg__["a" /* default */])({
        isEditData: true,
        guid: guid
      });
    }
  }
});

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_knowledgeTable_knowledgeTable__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_knowledgeTable_knowledgeTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_knowledgeTable_knowledgeTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_knowledgeDlg__ = __webpack_require__(337);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      loading: false,
      tempstr: '',
      guid: '',
      tmguid: '',
      id: -1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['knowledgeList']), {
    title: function title() {
      return '\u77E5\u8BC6\u70B9\u5217\u8868';
    }
  }),
  created: function created() {},

  components: {
    knowledgeTable: __WEBPACK_IMPORTED_MODULE_2__components_knowledgeTable_knowledgeTable___default.a,
    knowledgeDlg: __WEBPACK_IMPORTED_MODULE_3__components_knowledgeDlg__["a" /* default */]
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.$store.dispatch('actions_getKLByProblemGuid', this.tmguid);
      }
    }
  },
  methods: {
    addKnowledge: function addKnowledge() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_knowledgeDlg__["a" /* default */])({
        isEditData: false,
        tmguid: this.tmguid
      });
    }
  }
});

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_examineProblemDlg__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_solutionTableFatherDlg__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_knowledgeTableFatherDlg__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hintTableFatherDlg__ = __webpack_require__(526);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      problemGuid: 1,
      cols: [{
        prop: 'guid',
        label: 'guid',
        width: 150
      }, {
        prop: 'main',
        label: '主题号',
        width: 80
      }, {
        prop: 'minor',
        label: '子题号',
        width: 80
      }, {
        prop: 'type1',
        label: '类别1',
        width: 100
      }, {
        prop: 'type2',
        label: '类别2',
        width: 100
      }, {
        prop: 'title',
        label: '标题',
        width: 120
      }, {
        prop: 'keyword',
        label: '关键词',
        width: 120
      }, {
        prop: 'amark',
        label: '答案标记',
        width: 120
      }, {
        prop: 'aformat',
        label: '答案格式',
        width: 120
      }, {
        prop: 'answer',
        label: '答案',
        width: 120
      }]
    };
  },

  props: ['tableData'],
  computed: {
    tabH: function tabH() {
      return this.winH - (this.search ? this.search.getHeight() : 80) - 88;
    }
  },
  methods: {
    edit: function edit(guid) {
      console.log('examineProblemDlg->edit id = ', guid);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_examineProblemDlg__["a" /* default */])({
        isEditData: true,
        guid: guid
      });
    },
    gotoSolutionList: function gotoSolutionList(guid) {
      console.log('solutionTableFatherDlg->edit id = ', guid);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_solutionTableFatherDlg__["a" /* default */])({
        type: 0,
        tmguid: guid
      });
    },
    gotoKnowledgeList: function gotoKnowledgeList(guid) {
      console.log('knowledgeTableFatherDlg->edit id = ', guid);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_knowledgeTableFatherDlg__["a" /* default */])({
        type: 0,
        tmguid: guid
      });
    },
    gotoHintList: function gotoHintList(guid) {
      console.log('hintTableFatherDlg->edit id = ', guid);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_hintTableFatherDlg__["a" /* default */])({
        type: 0,
        tmguid: guid
      });
    },
    searchProblem: function searchProblem() {},
    deleteProblem: function deleteProblem(guid) {}
  }
});

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      form: {
        problemMain: '0',
        problemGuid: '',
        keywords: '',
        title: '',
        qt: ''
      }
    };
  },

  methods: {
    search: function search() {
      console.log('problemSearch->search()');
      this.$emit('search', this.form);
    },
    searchAll: function searchAll() {
      console.log('problemSearch->searchAll()');
      this.form = {
        problemMain: '',
        problemGuid: '',
        keywords: '',
        title: '',
        qt: ''
      };
      this.search();
    },
    getHeight: function getHeight() {
      return this.$refs.searchDiv.offsetHeight;
    }
  }
});

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_solution_js__ = __webpack_require__(104);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      loading: false,
      tempstr: '',
      guid: '',
      tmguid: '',
      isEditData: false,
      sInfo1: {
        pguid: '',
        content: '',
        author2Guid: '' },
      quill: null
    };
  },

  computed: {
    title: function title() {
      return '\u7F16\u8F91\u89E3\u7B54\u8FC7\u7A0B-' + (this.isEditData === true ? '修改' : '新增');
    }
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.markDown();
      }
      this.sInfo1.pguid = this.tmguid;
    }
  },
  methods: {
    markDown: function markDown() {
      var _this = this;

      setTimeout(function () {
        if (!_this.quill) {
          _this.quill = new window.Quill('#editor-container-jtgc', {
            modules: {
              formula: true,
              syntax: true,
              toolbar: {
                container: '#toolbar-container-jtgc',
                handlers: {
                  image: _this.imageHandler
                }
              }
            },
            placeholder: 'Compose an epic...',
            theme: 'snow'
          });
        }
        if (_this.isEditData === true) {
          _this.loadData();
        }
      }, 1000);
    },
    imageHandler: function imageHandler() {
      console.log('65');
      var range = this.quill.getSelection();
      var value = prompt('What is the image URL');
      this.quill.insertEmbed(range.index, 'image', value, window.Quill.sources.USER);
    },
    closeDlg: function closeDlg() {
      this.show = false;
    },
    showMsg: function showMsg(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';

      this.$notify({
        title: '解题过程',
        message: msg,
        type: type
      });
    },
    saveSolution: function saveSolution() {
      var _this2 = this;

      this.sInfo1.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.quill.getContents());

      if (this.isEditData === false) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_solution_js__["b" /* addNewSolution */])(this.sInfo1).then(function (res) {
          if (res.data) {
            if (res.data.isOk === true) {
              _this2.showMsg('添加解题过程成功。', 'info');
            } else {
              _this2.showMsg('添加解题过程失败。', 'info');
            }
          } else {
            _this2.showMsg('添加解题过程不成功。', 'info');
          }
        }).catch(function (err) {
          _this2.showMsg('\u6DFB\u52A0\u89E3\u9898\u8FC7\u7A0B\u5931\u8D25\u3002' + err);
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_solution_js__["c" /* updateSolutionByGuid */])(this.sInfo1).then(function (res) {
          if (res.data) {
            if (res.data.isOk === true) {
              _this2.showMsg('修改解题过程成功。', 'info');
            } else {
              _this2.showMsg('修改解题过程失败。', 'info');
            }
          } else {
            _this2.showMsg('修改解题过程不成功。', 'info');
          }
        }).catch(function (err) {
          _this2.showMsg('\u4FEE\u6539\u89E3\u9898\u8FC7\u7A0B\u5931\u8D25\u3002' + err);
        });
      }
    },
    loadData: function loadData() {
      var _this3 = this;

      if (this.isEditData === true) {
        this.loading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_solution_js__["d" /* getSolutionByGuid */])(this.guid).then(function (res) {
          var data = res.data;
          if (data.isOk) {
            _this3.sInfo1 = data.data[0];
            var tm = JSON.parse(_this3.sInfo1.content);
            console.log(tm.ops);
            if (_this3.quill) {
              _this3.quill.setContents(tm.ops);
              _this3.quill.enable(true);
            } else {
              console.log('quill初始化失败。');
            }
          } else {
            _this3.showMsg('获取解题方法失败，请关闭修改对话框后重新再试！');
          }
          _this3.loading = false;
        }).catch(function (err) {
          _this3.showMsg(err);
          _this3.loading = false;
        });
      }
    }
  }
});

/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_solutionTable_solutionTable__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_solutionTable_solutionTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_solutionTable_solutionTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_solutionDlg__ = __webpack_require__(521);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      loading: false,
      tempstr: '',
      guid: '',
      tmguid: '',
      id: -1
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['solutionList']), {
    title: function title() {
      return '\u89E3\u9898\u8FC7\u7A0B\u5217\u8868';
    }
  }),
  created: function created() {},

  components: {
    solutionTable: __WEBPACK_IMPORTED_MODULE_2__components_solutionTable_solutionTable___default.a,
    solutionDlg: __WEBPACK_IMPORTED_MODULE_3__components_solutionDlg__["a" /* default */]
  },
  watch: {
    show: function show(val) {
      if (val) {
        this.$store.dispatch('actions_getSolutionList', this.tmguid);
      }
    }
  },
  methods: {
    addSolution: function addSolution() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_solutionDlg__["a" /* default */])({
        isEditData: false,
        tmguid: this.tmguid
      });
    }
  }
});

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_solutionDlg__ = __webpack_require__(521);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cols: [{
        prop: 'guid',
        label: 'guid',
        width: 150
      }, {
        prop: 'pguid',
        label: '题目id',
        width: 80
      }, {
        prop: 'title',
        label: '标题',
        width: 80
      }, {
        prop: 'content',
        label: '内容',
        width: 80
      }, {
        prop: 'author2Guid',
        label: '原作者Guid',
        width: 100
      }, {
        prop: 'date',
        label: '日期',
        width: 100
      }, {
        prop: 'up',
        label: '赞数',
        width: 150
      }, {
        prop: 'favorite',
        label: '收藏数',
        width: 120
      }, {
        prop: 'discuss',
        label: '讨论数',
        width: 150
      }]
    };
  },

  props: ['tableData'],
  computed: {
    tabH: function tabH() {
      return this.winH - (this.search ? this.search.getHeight() : 80) - 88;
    }
  },
  methods: {
    edit: function edit(guid) {
      console.log('solutionDlg->edit guid = ', guid);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_solutionDlg__["a" /* default */])({
        isEditData: true,
        guid: guid
      });
    }
  }
});

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_search_problemSearch__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_search_problemSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_search_problemSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_problemTable_problemTable__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_problemTable_problemTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_problemTable_problemTable__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      problemMain: '0',
      problemGuid: '',
      keywords: '',
      title: '',
      qt: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['problemList', 'pageIndex', 'rows', 'total'])),
  created: function created() {},

  components: {
    problemTable: __WEBPACK_IMPORTED_MODULE_4__components_problemTable_problemTable___default.a,
    problemSearch: __WEBPACK_IMPORTED_MODULE_3__components_search_problemSearch___default.a
  },
  mounted: function mounted() {
    this.getPagedProblem({});
  },

  methods: {
    getPagedProblem: function getPagedProblem(_ref) {
      var _this = this;

      var _ref$problemMain = _ref.problemMain,
          problemMain = _ref$problemMain === undefined ? this.problemMain : _ref$problemMain,
          _ref$problemGuid = _ref.problemGuid,
          problemGuid = _ref$problemGuid === undefined ? this.problemGuid : _ref$problemGuid,
          _ref$keywords = _ref.keywords,
          keywords = _ref$keywords === undefined ? this.keywords : _ref$keywords,
          _ref$title = _ref.title,
          title = _ref$title === undefined ? this.title : _ref$title,
          _ref$qt = _ref.qt,
          qt = _ref$qt === undefined ? this.qt : _ref$qt;

      this.problemMain = problemMain;
      this.problemGuid = problemGuid;
      this.keywords = keywords;
      this.title = title;
      this.qt = qt;
      var getTotal = this.$store.dispatch('actions_getProblemTotal', [problemMain, problemGuid, keywords, title, qt]);
      var getList = this.$store.dispatch('actions_getProblemList', [problemMain, problemGuid, keywords, title, qt, this.pageIndex, this.rows]);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([getTotal, getList]).then(function (values) {
        _this.loading = false;
      }).catch(function (errs) {
        _this.loading = false;
        console.log(errs);
      });
    },
    pageSizeChange: function pageSizeChange(ps) {
      this.$store.commit('SET_ROWS', ps);
      this.getPagedProblem({});
    },
    pageIndexChange: function pageIndexChange(pi) {
      this.$store.commit('SET_PAGE_INDEX', pi);
      this.getPagedProblem({});
    }
  }
});

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"solutionTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".ctitle[data-v-3f03917f]{height:56px;width:100%;text-align:center}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/problemList.vue"],"names":[],"mappings":"AACA,yBACE,YAAa,AACb,WAAY,AACZ,iBAAmB,CACpB","file":"problemList.vue","sourcesContent":["\n.ctitle[data-v-3f03917f]{\n  height: 56px;\n  width: 100%;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"problemSearch.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"main.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"hintTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".h20{height:20px}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/components/problemTable/problemTable.vue"],"names":[],"mappings":"AACA,KACE,WAAa,CACd","file":"problemTable.vue","sourcesContent":["\n.h20{\n  height: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(564);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("689b532a", content, true);

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(575);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("1a290fe8", content, true);

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(577);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("f219f7c0", content, true);

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(580);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("43641c8a", content, true);

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(581);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("570a04b9", content, true);

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(582);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("604ea260", content, true);

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(584);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("c667ea1c", content, true);

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(585);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("539866a8", content, true);

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(586);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("59556fbe", content, true);

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(587);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("1ff94586", content, true);

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(608)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(648),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(604)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(644),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(613)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(653),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(607)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(647),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(614)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(654),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(649),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(611)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(651),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(612)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(652),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(631),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 631:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "height": _vm.tabH
    }
  }, [_vm._l((_vm.cols), function(col) {
    return _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "show-overflow-tooltip": ""
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "修改",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('problem-search', {
    ref: "s",
    on: {
      "search": _vm.getPagedProblem
    }
  }), _vm._v(" "), _c('problem-table', {
    attrs: {
      "tableData": _vm.problemList
    }
  }), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": [20, 30, 40, 50],
      "page-size": _vm.rows,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctitle"
  }, [_c('h2', [_vm._v("正式题目列表")])])
}]}

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.type === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('div', [_c('el-button', {
    on: {
      "click": _vm.addHint
    }
  }, [_vm._v("新增解题提示")])], 1), _vm._v(" "), _c('hint-table', {
    attrs: {
      "tableData": _vm.hintList
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.type === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('div', [_c('el-button', {
    on: {
      "click": _vm.addKnowledge
    }
  }, [_vm._v("新增知识点2")])], 1), _vm._v(" "), _c('knowledge-table', {
    attrs: {
      "tableData": _vm.knowledgeList
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("关联其它知识点,方式，拷贝本题guid，然后到知识点列表中查找到相应知识点，在其后点关联")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("本题guid ：" + _vm._s(_vm.tmguid))])])])
},staticRenderFns: []}

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "hInfo1",
    attrs: {
      "model": _vm.hInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "pGuid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "题目guid"
    },
    model: {
      value: (_vm.hInfo1.pGuid),
      callback: function($$v) {
        _vm.hInfo1.pGuid = $$v
      },
      expression: "hInfo1.pGuid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "标题，如205题提示一、二等"
    },
    model: {
      value: (_vm.hInfo1.title),
      callback: function($$v) {
        _vm.hInfo1.title = $$v
      },
      expression: "hInfo1.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提示级别"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "提示级别，正整数"
    },
    model: {
      value: (_vm.hInfo1.hLevel),
      callback: function($$v) {
        _vm.hInfo1.hLevel = $$v
      },
      expression: "hInfo1.hLevel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.saveHint
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("提示内容")])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "margin": "50px auto",
      "max-width": "100%"
    },
    attrs: {
      "id": "standalone-container-jtgc"
    }
  }, [_c('div', {
    attrs: {
      "id": "toolbar-container-jtgc"
    }
  }, [_c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-font"
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-size"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-bold"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-italic"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-underline"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-strike"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-color"
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-background"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-script",
    attrs: {
      "value": "sub"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-script",
    attrs: {
      "value": "super"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-header",
    attrs: {
      "value": "1"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-header",
    attrs: {
      "value": "2"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-blockquote"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-code-block"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-list",
    attrs: {
      "value": "ordered"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-list",
    attrs: {
      "value": "bullet"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-indent",
    attrs: {
      "value": "-1"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-indent",
    attrs: {
      "value": "+1"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-direction",
    attrs: {
      "value": "rtl"
    }
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-align"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-link"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-image"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-video"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-formula"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-clean"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "id": "editor-container-jtgc"
    }
  })])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "searchDiv"
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "text-align": "left",
      "padding-top": "20px"
    },
    attrs: {
      "model": _vm.form,
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "题目编号",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.form.problemGuid),
      callback: function($$v) {
        _vm.form.problemGuid = $$v
      },
      expression: "form.problemGuid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主题号",
      "label-width": "60px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.form.problemMain),
      callback: function($$v) {
        _vm.form.problemMain = $$v
      },
      expression: "form.problemMain"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关键词",
      "label-width": "60px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.form.keywords),
      callback: function($$v) {
        _vm.form.keywords = $$v
      },
      expression: "form.keywords"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "60px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.form.title = $$v
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其他",
      "label-width": "40px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.form.qt),
      callback: function($$v) {
        _vm.form.qt = $$v
      },
      expression: "form.qt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.searchAll
    }
  }, [_vm._v("全部")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "sInfo1",
    attrs: {
      "model": _vm.sInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "pguid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "题目id"
    },
    model: {
      value: (_vm.sInfo1.pguid),
      callback: function($$v) {
        _vm.sInfo1.pguid = $$v
      },
      expression: "sInfo1.pguid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "标题,60字以内"
    },
    model: {
      value: (_vm.sInfo1.title),
      callback: function($$v) {
        _vm.sInfo1.title = $$v
      },
      expression: "sInfo1.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原作者GUID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "原作者GUID，需查出来填写，没有时需填0，表示系统提供的解题过程"
    },
    model: {
      value: (_vm.sInfo1.author2Guid),
      callback: function($$v) {
        _vm.sInfo1.author2Guid = $$v
      },
      expression: "sInfo1.author2Guid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.saveSolution
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("解答内容")])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticStyle: {
      "margin": "50px auto",
      "max-width": "100%"
    },
    attrs: {
      "id": "standalone-container-jtgc"
    }
  }, [_c('div', {
    attrs: {
      "id": "toolbar-container-jtgc"
    }
  }, [_c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-font"
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-size"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-bold"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-italic"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-underline"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-strike"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-color"
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-background"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-script",
    attrs: {
      "value": "sub"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-script",
    attrs: {
      "value": "super"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-header",
    attrs: {
      "value": "1"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-header",
    attrs: {
      "value": "2"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-blockquote"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-code-block"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-list",
    attrs: {
      "value": "ordered"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-list",
    attrs: {
      "value": "bullet"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-indent",
    attrs: {
      "value": "-1"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-indent",
    attrs: {
      "value": "+1"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-direction",
    attrs: {
      "value": "rtl"
    }
  }), _vm._v(" "), _c('select', {
    staticClass: "ql-align"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-link"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-image"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-video"
  }), _vm._v(" "), _c('button', {
    staticClass: "ql-formula"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-clean"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "id": "editor-container-jtgc"
    }
  })])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.type === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('div', [_c('el-button', {
    on: {
      "click": _vm.addSolution
    }
  }, [_vm._v("新增解题过程")])], 1), _vm._v(" "), _c('solution-table', {
    attrs: {
      "tableData": _vm.solutionList
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 653:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "height": _vm.tabH
    }
  }, [_vm._l((_vm.cols), function(col) {
    return _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "show-overflow-tooltip": ""
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "修改",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "height": _vm.tabH
    }
  }, [_vm._l((_vm.cols), function(col) {
    return _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "show-overflow-tooltip": ""
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "修改",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "解题过程",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.gotoSolutionList(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "相关知识",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.gotoKnowledgeList(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "解题提示",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.gotoHintList(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "删除题目",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteProblem(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.f8adb42fba5cfb78ee26.js